import React, { ReactElement, useEffect } from 'react'
import { useRouter } from 'next/router'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { SearchBox } from '@/components/search/SearchBox/SearchBox'
import { isSearchBoxOpenAtom } from '@/atoms/isSearchBoxOpen'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { Logo } from '@/components/Logo/Logo'
import { frontendLogout } from '@/auth/frontendLogout'
import { ChooseFrontendDisplayedCourse } from '@/components/ChooseFrontendDisplayedCourse/ChooseFrontendDisplayedCourse'
import { useNotifications } from '@/hooks/useNotifications'
import { Badge } from 'antd'
import { BellOutlined, UnorderedListOutlined } from '@ant-design/icons'
import {
    isNotificationQueueModalVisibleAtom,
    isNotificationsModalVisibleAtom,
    numUnseenNotificationsSelector,
} from '@/atoms/notifications'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { NotificationModal } from '@/components/NotificationModal/NotificationModal'
import { NotificationQueueModal } from '@/components/NotificationQueueModal/NotificationQueueModal'
import { FeedbackDetailModal } from '@/components/FeedbackDetailModal/FeedbackDetailModal'
import { useModalUrlSync } from '@/hooks/useModalUrlSync'
import { useRefreshNotificationsByTimestamp } from '@/hooks/useRefreshNotificationsByTimestamp'
import { frontendDisplayedCourseSelector } from '@/atoms/auth'
import { TopNavigationSubProps } from '@/components/layout/TopNavigation/TopNavigation.types'
import { courseInfoAtom } from '@/atoms/courseInfo'

export const TopNavigationLoggedIn: React.FC<TopNavigationSubProps> = (
    props
): ReactElement => {
    const router = useRouter()
    useEffect(() => {
        if (props.page === UiLayoutConstant.SPLASH_PAGE) {
            router.replace({
                pathname: UiLayoutConstant.PRIMARY_DASHBOARD_PAGE,
            })
            return
        }
    }, [router, props.page])
    const [isSearchBoxOpen, setIsSearchBoxOpen] =
        useRecoilState<boolean>(isSearchBoxOpenAtom)
    useNotifications()
    useModalUrlSync()
    const numUnseenNotifications = useRecoilValue(
        numUnseenNotificationsSelector
    )
    const setIsNotificationModalVisible = useSetRecoilState<boolean>(
        isNotificationsModalVisibleAtom
    )
    const setIsNotificationQueueModalVisible = useSetRecoilState<boolean>(
        isNotificationQueueModalVisibleAtom
    )
    const courseName = useRecoilValue(frontendDisplayedCourseSelector)
    useRefreshNotificationsByTimestamp(courseName)
    const courseInfo = useRecoilValue(courseInfoAtom(courseName))
    return (
        <>
            <div className={'top-navigation'}>
                <Logo />
                <ChooseFrontendDisplayedCourse />
                <div className={reusableCssClass.centerChildrenVertically}>
                    Current course:{' '}
                    <span className={reusableCssClass.bold}>
                        Exam {courseInfo.abbreviation}: {courseInfo.prettyName}
                    </span>
                </div>
                <SearchBox
                    isVisible={isSearchBoxOpen}
                    setIsVisible={setIsSearchBoxOpen}
                />
                <div
                    className={`notifications-badge-container ${reusableCssClass.centerChildrenVertically}`}
                    onClick={() => setIsNotificationQueueModalVisible(true)}
                    title="Notification Queue"
                >
                    <UnorderedListOutlined />
                </div>
                <div
                    className={`notifications-badge-container ${reusableCssClass.centerChildrenVertically}`}
                    onClick={() => setIsNotificationModalVisible(true)}
                >
                    <Badge count={numUnseenNotifications}>
                        <BellOutlined />
                    </Badge>
                </div>
                <div
                    className={'logout-button'}
                    onClick={() => frontendLogout()}
                >
                    Logout
                </div>
            </div>
            <NotificationModal />
            <NotificationQueueModal />
            <FeedbackDetailModal />
        </>
    )
}
